import React, { useState } from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { WorkingWeek } from "@fidget/common/utils/getWorkingHours";
import { ListActionLabel } from "./listActionLabel";
import { HoursPicker } from "../settingsForms/workingHours/hoursPicker";

interface Props {
  text?: string;
  onPicked(hours: WorkingWeek): void;
}
export const ListHoursAction = ({
  text = intl.formatMessage("settings.tagGroups.action.setHours"),
  onPicked
}: Props) => {
  const [isPicking, setIsPicking] = useState(false);

  const handlePicked = (hours: WorkingWeek) => {
    onPicked(hours);
    setIsPicking(false);
  };

  return isPicking ? (
    <HoursPicker onPicked={handlePicked} onOpenedChange={() => setIsPicking(false)} />
  ) : (
    <ListActionLabel text={text} onClick={() => setIsPicking(true)} />
  );
};
